import * as React from 'react';
import { DatePicker } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const RangePicker = ({ element, elementStyle }) => {
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <DatePicker.RangePicker {...formItemSettings} className={className} />
    </FormItem>
  );
};

export default RangePicker;
